module.exports = __webpack_public_path__ + "static/media/icon_138.dc37099e.svg";